import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import { GetInvoicesDto } from '../../../models/dtos/getInvoices.dto';
import getInvoicesProblemRepository from './getProblemInvoices.repository';

type InitialState = {
  loading: boolean;
  data?: GetInvoicesDto[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getProblemInvoices = createAsyncThunk(
  'getProblemInvoices',
  async (active: any) => {
    return await getInvoicesProblemRepository(active).catch((error) => {
      throw error;
    });
  }
);

const getProblemInvoicesSlice = createSlice({
  name: 'getProblemInvoices',
  initialState,
  reducers: {
    getProblemInvoicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProblemInvoices.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
      getProblemInvoices.fulfilled,
      (state, action: PayloadAction<GetInvoicesDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getProblemInvoices.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getProblemInvoicesSlice.reducer;
export const { getProblemInvoicesReset } = getProblemInvoicesSlice.actions;
